// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"906":"f5a89dab","1801":"6bb25d77","1804":"6bb25d77","2078":"fa07287a","3604":"cf161adc","4182":"6bb25d77","6294":"9cd7eea8","8593":"6bb25d77"}[chunkId] + ".chunk.css";
};